module.exports = __webpack_public_path__ + "static/media/ain_ghazal_text_03.ee0dd3c0.jpg";